import React from "react"
import { Link } from "gatsby"
import CartIcon from "./cart/CartIcon"

const resolveFeatureFlag = (flagValue, enabledByMode) => {
  if (flagValue === "true") return true
  if (flagValue === "false") return false
  return enabledByMode
}

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showCollapsed: props.showCollapsed,
      hasScrolled: false,
      menuOpen: false,
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    const scrollTop = window.pageYOffset

    if (scrollTop > 50) {
      this.setState({ hasScrolled: true })
    } else {
      this.setState({ hasScrolled: false })
    }
  }

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen,
    }))
  }

  closeMenu = () => {
    this.setState({ menuOpen: false })
  }

  render() {
    let site = this.props.site !== undefined ? this.props.site : "none"
    const siteName = process.env.GATSBY_siteCompanyName || "Tienda"
    const siteMode =
      process.env.GATSBY_SITE_MODE || process.env.GATSBY_siteType || "booking"
    const isServicesEnabled = resolveFeatureFlag(
      process.env.GATSBY_ENABLE_SERVICES,
      siteMode !== "cart"
    )
    return (
      <div
        className={
          this.state.hasScrolled || this.state.showCollapsed
            ? `Header HeaderScrolled ${site}`
            : `Header ${site}`
        }
      >
        <div className="HeaderGroup">
          <Link className="HeaderBrand" to="/" onClick={this.closeMenu}>
            {siteName}
          </Link>

          <button
            className={`HeaderMenuToggle ${this.state.menuOpen ? "open" : ""}`}
            onClick={this.toggleMenu}
            aria-label="Abrir menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {this.state.menuOpen && (
            <div className="HeaderOverlay" onClick={this.closeMenu}></div>
          )}
          <nav
            className={`HeaderNav ${
              this.state.menuOpen ? "HeaderNavOpen" : ""
            }`}
          >
            <Link
              to="/"
              activeClassName="HeaderNavActive"
              onClick={this.closeMenu}
            >
              Inicio
            </Link>
            <Link
              to="/about"
              activeClassName="HeaderNavActive"
              onClick={this.closeMenu}
            >
              Nosotros
            </Link>
            {isServicesEnabled && (
              <Link to="/#servicios" onClick={this.closeMenu}>
                Servicios
              </Link>
            )}
            <Link to="/#productos" onClick={this.closeMenu}>
              Productos
            </Link>
          </nav>

          <CartIcon />
        </div>
      </div>
    )
  }
}

export default Header
